import React from 'react';
import { Card, Col, Row } from 'reactstrap';
import ForgotPasswordForm from '../components/ForgotPasswordForm';
import logo200Image from '../assets/img/logo/20200723_UnitySuiteSqLogo512.webp';
import Typography from '../components/Typography';

class ForgotPasswordPage extends React.Component {
  login = () => {
    this.props.history.push('/login');
  };

  render() {
    return (
      <div className="ps-background">
        <Row className="AuthPage">
          <Col md={12} lg={4} className="d-none d-lg-block">
            <img
              src={logo200Image}
              style={{
                width: 150,
                cursor: 'pointer',
                display: 'block',
                margin: '0 auto',
              }}
              alt="logo"
            />
            <Typography className="mt-5 text-center h1 intro-title">
              UnitySuitePro
            </Typography>
            <p className="text-center version">
              {process.env.REACT_APP_VERSION}
            </p>
          </Col>
          <Col md={12} lg={8}>
            <div className="ps-auth-form">
              <Card body className="card-1">
                <ForgotPasswordForm history={this.props.history} />
              </Card>
              <h6 className="text-center form-bottom">
                <span className="mr-2">Already have account?</span>
                <a className="link-2" href="#login" onClick={this.login}>
                  Login
                </a>
              </h6>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}
export default ForgotPasswordPage;
